<template>
  <div class="option-wrap">
    <div class="option-top">
      <div class="icon-48 w-embed">
        <ExcelIcon class="icon-48" />
      </div>
      <div class="option-info">
        <div class="big">
          <strong>{{ $t('Upload Excel template') }}</strong>
        </div>
        <div class="text-secondary">{{ $t('Fill it and upload here') }}</div>
      </div>
    </div>
    <div class="option-bottom">
      <Button
        type="secondary"
        size="small"
        class="desktop-show"
        @click.native.stop="downloadXlsxHandler({ loadingId: 'downloadTemplate' })"
      >
        <Spinner v-if="loadings.includes('downloadTemplate')" size="20" />
        <span v-else>1. {{ $t('Download template') }}</span>
      </Button>
      <Button
        type="secondary"
        class="mobile-show"
        @click.native.stop="downloadXlsxHandler({ loadingId: 'downloadTemplate' })"
      >
        <Spinner v-if="loadings.includes('downloadTemplate')" size="20" />
        <span v-else>1. {{ $t('Download template') }}</span>
      </Button>
      <span v-if="downloadXlsxError" class="warning-600">{{ downloadXlsxError }}</span>
      <Button class="mobile-show" type="primary" @click.native.stop="openExcelModal">
        2. {{ $t('Upload Excel') }}
      </Button>
      <Button class="desktop-show" size="small" type="primary" @click.native.stop="openExcelModal">
        2. {{ $t('Upload Excel') }}
      </Button>
    </div>
  </div>
</template>

<script>
  import ExcelIcon from '@/assets/icons/excel.svg';
  import Button from '@/components/ui-v2/Button';
  import { mapActions, mapState } from 'vuex';
  import Spinner from 'vue-simple-spinner';

  export default {
    name: 'UploadExcelOfPublicTender',
    components: {
      ExcelIcon,
      Button,
      Spinner,
    },
    computed: {
      ...mapState('publicTender', ['loadings', 'downloadXlsxError']),
    },
    methods: {
      ...mapActions('publicTender', ['openExcelModal', 'downloadXlsxHandler']),
    },
  };
</script>

<style scoped lang="scss">
  @import 'src/styles/pages/public-tender';
</style>
